import React from "react";
import AutoComplete from "@mui/material/Autocomplete";
import BaseComponent from "../../../base";
import { TextField, InputAdornment } from "@mui/material";
import { FormattedMessage, injectIntl } from "react-intl";
import SearchIcon from "@mui/icons-material/Search";
class SearchByManufacturer extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
    };
  }

  componentDidMount() {}
  onChange(value) {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }
  render() {
    const results = this.state.results.sort((a, b) => -b.localeCompare(a));
    return (
      <div>
        {
          <AutoComplete
            style={{ overflow: "hidden" }}
            clearOnEscape
            disableClearable
            freeSolo
            id="combo-box-demo"
            options={results}
            value={this.props.value ?? ""}
            inputValue={this.props.value ?? ""}
            onInputChange={(event, newInputValue) => {
              if (this.props.onChange) {
                this.props.onChange(newInputValue);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={this.props.intl.formatMessage({ id: "search.brands" })}
                variant="standard"
                fullWidth
                onKeyDown={(evt) => {
                  if (evt.key === "Enter" && this.props.onSubmitSearch) {
                    evt.preventDefault();
                    this.props.onSubmitSearch();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        }

        <br />
      </div>
    );
  }
}

export default injectIntl(SearchByManufacturer);

/*
     {<AutoComplete
          searchText={this.props.value}
          filter={(searchText, key) => searchText !== '' && key.toLowerCase().startsWith(searchText.toLowerCase())}
          maxSearchResults={5}
          floatingLabelText="Varumärke"
        dataSource={results}
        onUpdateInput={this.onChange.bind(this)}
        fullWidth
        />}

        */
